import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { Radio, RadioContainer } from 'jbc-front/components/presenters/form/Radio';
import { ErrorMessage } from 'jbc-front/components/presenters/form/ErrorMessage';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import type { Schema } from '../../schema';

export const OrderByDoctor: FC = () => {
  const {
    register,
    formState: { errors }
  } = useFormContext<Schema>();

  return (
    <Panel>
      <Headding>医師の指示対象</Headding>
      <Item>
        <div>
          <RadioContainer>
            <Radio {...register('orderByDoctor')} value="false">
              なし
            </Radio>
            <Radio {...register('orderByDoctor')} value="true">
              あり
            </Radio>
          </RadioContainer>
          {errors.orderByDoctor?.message && <ErrorMessage>{errors.orderByDoctor.message}</ErrorMessage>}
        </div>
      </Item>
    </Panel>
  );
};
